import { StoreState } from '@/core/models/store.interface';
import { CancelToken } from 'axios';
import { Module } from 'vuex';
import candidatePoolSquadService from './candidate-pool-squad.service';

export interface CandidatePoolSquadState { }

const CandidatePoolSquadStore: Module<CandidatePoolSquadState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async get(
         context,
         {
            squad_id,
            candidate_pool_id,
            page,
            per_page,
            date_between,
            candidate_filter,
            search,
            cancelToken,
            include_all_slots = false,
            with_slots_sum_seconds_planned,
            without_trashed_candidate_pools,
            with_no_overlapping_slots,
            includes,
         }: {
            squad_id: number;
            candidate_pool_id: number;
            page: number;
            per_page: number;
            date_between: string;
            candidate_filter: string;
            search: string;
            cancelToken: cancelToken;
            include_all_slots?: boolean;
            with_slots_sum_seconds_planned?: boolean;
            without_trashed_candidate_pools?: boolean;
            with_no_overlapping_slots?: number;
            includes?: string;
         },
      ) {
         return await candidatePoolSquadService
            .get({
               squad_id,
               candidate_pool_id,
               page,
               per_page,
               date_between,
               candidate_filter,
               search,
               cancelToken,
               include_all_slots,
               with_slots_sum_seconds_planned,
               without_trashed_candidate_pools,
               with_no_overlapping_slots,
               includes,
            })
            .then((response) => response);
      },

      async getById({ }, { id, cancelToken }: { id: number; cancelToken: CancelToken }) {
         return await candidatePoolSquadService.getById(id, cancelToken);
      },
   },
};

export default CandidatePoolSquadStore;
